import React from "react";

import Select from "react-select";

/**
 * A custom select component that wraps the React Select library and forwards the ref.
 * @param {object} props - The props for the component.
 * @param {array} props.options - The options to display in the select dropdown.
 * @param {boolean} props.isMulti - Whether multiple options can be selected.
 * @param {function} props.onChange - The callback function to handle option selection changes.
 * @param {object} props.components - Custom components to be used in the select.
 * @param {function} props.formatOptionLabel - The function to format the label of each option.
 * @param {React.Ref} ref - The ref to forward to the underlying Select component.
 * @returns The custom select component.
 */
const CustomeSelect = React.forwardRef((props, ref) => {
  /**
   * Destructures the properties from the props object.
   * @param {object} props - The props object containing the properties to destructure.
   * @returns None
   */
  const {
    options,
    isMulti,
    onChange,
    components,
    formatOptionLabel,
    isDisabled,
    defaultValue,
    value,
    className,
    menuIsOpen,
    closeMenuOnSelect,
    classNamePrefix,
    isClearable,
    placeholder,
    isOptionDisabled,
    isSearchable
  } = props;
  /**
   * Renders a SelectBox component with the provided props.
   * @param {React.Ref} ref - A reference to the Select component.
   * @param {Array} defaultValue - The default selected value(s) of the Select component.
   * @param {boolean} isMulti - Determines if multiple options can be selected.
   * @param {boolean} closeMenuOnSelect - Determines if the dropdown menu should close after an option is selected.
   * @param {boolean} hideSelectedOptions - Determines if selected options should be hidden from the dropdown menu.
   * @param {function} onChange - The callback function to be called when the selected value(s) change.
   * @param {function} formatOptionLabel - The function to format the label of each
   */

  return (
    <div className="SelectBox">
      <Select
        ref={ref}
        defaultValue={defaultValue}
        isMulti={isMulti}
        isClearable={isClearable}
        isSearchable={isSearchable}
        closeMenuOnSelect={closeMenuOnSelect}
        hideSelectedOptions={false}
        onChange={onChange}
        placeholder={placeholder}
        formatOptionLabel={formatOptionLabel}
        options={options}
        components={components}
        isDisabled={isDisabled}
        isOptionDisabled={isOptionDisabled}
        menuIsOpen={menuIsOpen}
        value={value}
        className={className + " react-select-container"}
        classNamePrefix={classNamePrefix + " react-select"}
      />
    </div>
  );
});

export default CustomeSelect;
